const BackChevron = ({ width = 12, height = 12 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 3L4 6L7 9" stroke="#3C3C3B" strokeLinecap="square" />
  </svg>
);

export default BackChevron;
